<template lang="pug">
  b-modal.send-email-form-modal(
    ref="modal"
    title="Enviar F29"
    v-bind="$attrs"
    @show="onReset"
    @ok="onSubmit"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    :ok-title="loading ? '🔄 Descargando...' : 'Enviar'")
    b-form
      b-form-group(label="Email")
        VueTagsInput(
          v-model="contactTagValue"
          placeholder="Correos de Contacto"
          :tags="contactTags"
          :validation="contactTagValidations"
          @tags-changed="newTags => { contactTags = newTags; contactTagValue = '' }"
        )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.email.required") Campo requerido

      b-form-group(label="Agregar periodos")
        .d-flex.align-items-center.mb-2
          b-select.mr-2(v-model="selectedMonth")
            b-select-option(:value="null") Mes
            b-select-option(v-for="month in months" :key="month.value" :value="month.value") {{ month.text }}
          b-select.mr-2(v-model="selectedYear" style="width: 100px;")
            b-select-option(:value="null") Año
            b-select-option(v-for="year in years" :key="year" :value="year") {{ year }}
          b-button(
            variant="primary"
            size="sm"
            @click="addPeriod"
            :disabled="!selectedMonth || !selectedYear"
          ) Agregar
        
        .text-danger.small(v-if="showMaxPeriodsError") Puedes añadir hasta 4 períodos
        
        .mt-2(v-if="dateTags.length > 0")
          VueTagsInput(
            v-model="dateTagValue"
            placeholder="Períodos seleccionados"
            :tags="dateTags"
            :add-only-from-autocomplete="true"
            :autocomplete-items="[]"
            @tags-changed="onDateTagsChanged"
            readonly
          )
        

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { emailValidator } from '../../shared/validations'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  inheritAttrs: false,
  components: {
    VueTagsInput
  },
  data () {
    return {
      contactTags: [],
      contactTagValue: '',
      contactTagValidations: [
        {
          classes: 'avoid-item',
          rule: ({ text }) => !emailValidator(text)
        }
      ],
      loading: false,
      defaultEmail: '',
      businessId: null,
      form: {},
      selectedMonth: null,
      selectedYear: null,
      dateTags: [],
      dateTagValue: '',
      showMaxPeriodsError: false,
      months: [
        { value: 1, text: 'Enero' },
        { value: 2, text: 'Febrero' },
        { value: 3, text: 'Marzo' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Mayo' },
        { value: 6, text: 'Junio' },
        { value: 7, text: 'Julio' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Septiembre' },
        { value: 10, text: 'Octubre' },
        { value: 11, text: 'Noviembre' },
        { value: 12, text: 'Diciembre' }
      ]
    }
  },
  computed: {
    years () {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let year = currentYear; year >= 1983; year--) {
        years.push(year)
      }
      return years
    }
  },
  validations: {
    form: {
      email: { required }
    }
  },
  methods: {
    ...mapActions(['sendF29']),
    addPeriod () {
      // Limpiar mensaje de error previo
      this.showMaxPeriodsError = false
      
      if (this.selectedMonth && this.selectedYear) {
        // Verificar límite de 4 períodos
        if (this.dateTags.length >= 4) {
          this.showMaxPeriodsError = true
          return
        }
        
        // Verificar que no exista ya esta combinación
        const exists = this.dateTags.some(tag => 
          tag.month === this.selectedMonth && tag.year === this.selectedYear
        )
        
        if (!exists) {
          const periodText = `${this.getMonthName(this.selectedMonth)} ${this.selectedYear}`
          this.dateTags.push({
            text: periodText,
            month: this.selectedMonth,
            year: this.selectedYear
          })
          // Limpiar selección
          this.selectedMonth = null
          this.selectedYear = null
        }
      }
    },
    onDateTagsChanged (newTags) {
      this.dateTags = newTags
      this.dateTagValue = ''
      // Limpiar mensaje de error si se elimina un período
      this.showMaxPeriodsError = false
    },
    removePeriod (index) {
      this.dateTags.splice(index, 1)
      // Limpiar mensaje de error si se elimina un período
      this.showMaxPeriodsError = false
    },
    getMonthName (monthNumber) {
      const month = this.months.find(m => m.value === monthNumber)
      return month ? month.text : ''
    },
    showModal (options) {
      this.defaultEmail = options.defaultEmail || ''
      this.businessId =  options.businessId || null
      this.contactTags = options.defaultEmail ? options.defaultEmail.split(',').map(e => { return { text: e } }) : []
      this.$refs.modal.show()
    },
    onReset () {
      this.$v.$reset()
      this.form = {
        email: this.defaultEmail
      }
      this.contactTagValue = ''
      this.dateTagValue = ''
      this.loading = false
      this.selectedMonth = null
      this.selectedYear = null
      this.dateTags = []
      this.showMaxPeriodsError = false
    },
    async onSubmit (e) {
      if(this.$v.$invalid) {
        this.$v.$touch()
        e.preventDefault()
      } else {
        // Activar estado de loading
        this.loading = true
        
        const data = {
          businessId: this.businessId,
          emails: this.form.email.split(','),
          dates: this.dateTags.map(tag => ({
            month: this.getMonthName(tag.month),
            year: tag.year
          }))
        }
        
        // Mostrar toast de inicio del proceso
        this.$root.$bvToast.toast(
          `Iniciando descarga de formulario${data.dates.length > 1 ? 's' : ''} F29...`, 
          {
            title: 'Proceso iniciado',
            variant: 'info',
            autoHideDelay: 4000
          }
        )
        
        const response = await this.sendF29({ data })
        const status = response.status
        
        // Usar el toast que viene del servidor si está disponible, sino usar la lógica anterior
        if (response.data.toast) {
          this.$root.$bvToast.toast(response.data.toast.message, {
            title: response.data.toast.title,
            variant: response.data.toast.variant
          })
        } else {
          // Fallback a la lógica anterior si no hay toast en la respuesta
          this.$root.$bvToast.toast(response.data.message, {
            title: status >= 200 && status < 300 ? 'Éxito!!' : 'Oops!!',
            variant: status >= 200 && status < 300 ? 'success' : 'danger'
          })
        }
      }
      // Desactivar estado de loading al final
      this.loading = false
    }
  },
  watch: {
    /**
     * Actualiza los email de contato separados por "," cada vez que cambian los tags de contacto
     */
    contactTags () {
      this.form.email = this.contactTags.map(e => e.text.trim()).join(',')
    }
  },
}
</script>
